// 通用的处理函数
export function handleBridgeResponse(res, successCallback, errorMessage) {
  const result = res.result
  if (result.code !== 0) {
    console.error(errorMessage, result.errorMsg)
  } else {
    console.log(`${errorMessage}成功:`, result.data)
    successCallback(result.data)
  }
}
